import { inject, Injector, Pipe, PipeTransform } from '@angular/core';
import {
  base64Encode,
  ConnectionHttpService,
  ApiResourceLocation,
  RequestEvent,
  ResponseRequestEvent,
  Store
} from '@softline/core';
import { filter, map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Artstamm } from '../types/artstamm';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { PictureResourceService } from '../services/picture-resource.service';

@Pipe({
  name: 'loadArchiveFile',
  standalone: true,
})
export class LoadArchiveFilePipe implements PipeTransform {

  private cachedImage?: SafeUrl;

  constructor(
    private service: ConnectionHttpService,
    private store: Store,
    private sanitizer: DomSanitizer,
    private pictureService: PictureResourceService
  ) {}

  async transform(artikel: Artstamm): Promise<SafeUrl> {
    if (this.cachedImage)
      return this.cachedImage;

    const mediaObject = await firstValueFrom(
      this.pictureService
        .load(artikel.id + '')
        .pipe(
          tap(o => console.log(o)),
          map(({ media = [] }) => Array.isArray(media) && media?.length > 0 ? media[0] : undefined)
        )
    );

    console.log(mediaObject);

    if (!mediaObject)
      return '';

    const query = base64Encode(JSON.stringify(mediaObject));
    const location: ApiResourceLocation = {
      path: '/v2/file/{{query}}',
      pathParams: { query }
    };

    this.cachedImage = await lastValueFrom(
      this.service.download(location).pipe(
      filter((o): o is ResponseRequestEvent<Blob> => o.type === 'response'),
      map((data: ResponseRequestEvent<Blob>) => this.makeSafeUrl2(data?.response)),
    ));

    return this.cachedImage ?? undefined;
  }

  private makeSafeUrl(data: ArrayBuffer): SafeUrl {
    const binaryData: any[] = [];
    binaryData.push(data);
    const unsafeUrl = URL.createObjectURL(new Blob(binaryData))
    return this.sanitizer.bypassSecurityTrustUrl(unsafeUrl)
  }

  private makeSafeUrl2(data: Blob | null): SafeUrl {
    const unsafeUrl = URL.createObjectURL(data ?? new Blob())
    return this.sanitizer.bypassSecurityTrustUrl(unsafeUrl)
  }
}
